import { PreviewLinesOption } from '../store/schema/PreviewLinesOption';
import { isSingleLineListView } from 'owa-mail-layout';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

// Display rules must not overwrite the saved preview preference.
export default function resolvePreviewLinesForDisplay(
    previewLines: number,
    isSingleLineView: boolean = isSingleLineListView(),
    win32StylingEnabled: boolean = isWin32StylingEnabled()
): number {
    if (previewLines === PreviewLinesOption.ThreeLines && !win32StylingEnabled) {
        return PreviewLinesOption.TwoLines;
    }

    return previewLines === PreviewLinesOption.Inline && !isSingleLineView
        ? PreviewLinesOption.Off
        : previewLines;
}
